import BaseRepository from "./BaseRepository";
import Helper from "../support/Helper";
import CartService from "../service/Cart";
import Cart from "../model/Cart";
import { event, system_notification } from "../store/slice/system";
import store from "../storeWire";
import ProductRepository from "./ProductRepository";
import ProductInventory from "src/model/ProductInventory";
import Auth from "@system/config/auth";
import { SET_BULK_CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT, SET_CART_SHIPPING_ADDRESS_ID, SET_CART_WEB_ORDER_ID, SET_CART_LOADER_DATA_OBJECT, SET_CLEAR_ALL_CART } from "../store/slice/model/Cart";
import { __set, __remove } from "../store/axios_indicator";
import { isArray, isObject } from "underscore";
import ProductPricingAPICall from "src/service/ProductPricingAPICall";
import CartCommon from "../component/Global/Cart/Common";
import produceClone from "src/helper/produceClone";
import System from "../helper/system";
import Constants from "src/support/Constants";
import ResponseMaker from "src/service/ProductListingAPICall/responseMaker";
import Common from "../component/Global/Cart/Common";

// 9063 - DT - 2Feb23 - Update Condition & ManufactureCode (set ManufactureCode from API, NOT from product) to check valid Quote Product valid for this address or not
class CartRepository extends BaseRepository {
  LOCAL_STORAGE_NAME = 'CART';

  get_LOCAL_STORAGE_NAME = () => {
    return this.LOCAL_STORAGE_NAME + Auth.getAuthSBoat();
  };

  fetchCartCount = async () => {
    let res = await new CartService().getCartCount();
    new Cart().setCartCount({
      CART_COUNT: res.data.count
    });
    return res;
  };

  fetchCartData = async (validaCart = false, params = {}) => {
    const res = await new CartService().getCartFromServer(params, validaCart);

    if (res?.data && res.data.length) {
      const cartData = res.data;
      const cart = new Cart();

      if (!validaCart) {
        const respon = {
          data: {
            products: cartData?.map((v) => {
              const product = v.product || {};
              v.isProductAvailableFromMainAPI = v.product ? true : false;
              const CPNData = product?.customerPartNumbers?.map((item) => {
                return Object.keys(item).reduce((acc, key) => {
                  acc[key.toUpperCase()] = item[key];
                  return acc;
                }, {});
              });
              return {
                ItemNumber: v.itemNumber,
                WCSPartNumber: `U|||${v.erpManufacturerCode}|||${product?.erpPartNumber}`,
                ERPMFRPartNumber: v.erpMfrPartNumber,
                CustomerPartNumbers: CPNData,
                ECCNCode: product.eccnCode,
                distributor: product.distributor,
                EndofLifeFlag: product.endofLifeFlag,
                ERPPartNumber: product.erpPartNumber,
                // ExcessInventoryFlag: product.excessInventoryFlag,
                FactoryLeadTime: product.factoryLeadTime,
                HTSCode: product.htsCode,
                NCNRFlag: product.ncnrFlag,
                NPIFlag: product.npiFlag,
                ObsoleteFlag: product.obsoleteFlag,
                PackagingTypeCode: product.packagingTypeCode,
                QtyMin: product.qtyMin,
                QtyMult: product.qtyMult,
                ROHSCompliantCode: product.rohsCompliantCode,
                sap_tla_type_cd: product.sap_tla_type_cd,
                SAPMaterialPricingGroupCode: product.sapMaterialPricingGroupCode,
                ScheduleBCode: product.scheduleBCode,
                ShortDescription: product.shortDescription,
                TopSellerFlag: product.topSellerFlag,
                WebOnlyFlag: product.webOnlyFlag,
                MDMMaterialID: v.mdmMaterialId,
                default_plant: v.default_plant,
                IsTariffEligible: product.isTariffEligible,
                factory_qoh: product.factory_qoh,
                exists_in_sap: product.exists_in_sap,
                ManufacturerPartNumber: v.manufacturerPartNumber,
                SoftwareDownloadFlag: v.isSoftwareDownloadable,
                custom_reel_flag: product.custom_reel_flag,
                HazardousFlag: product.hazardousFlag,
                Subtotal: v.subtotal,
                UnitPrice: v.unitPrice,
                Min: product?.qtyMin,
                Mult: product?.qtyMult,
                Stock: product?.stock,
              };
            }),
          },
        };

        let res_made = new ResponseMaker(respon).process().run().get();

        const cartProductData = res_made.value.reduce((acc, item) => {
          acc[item.ItemNumber] = item;
          acc[item.ERPPartNumber] = item;
          return acc;
        }, {});

        let rowInventoryData = cartData.map(cartItem => {
          return {
            matnr: cartItem.partNumber,
            plifz: cartItem.plifz,
            qas: cartItem.qas,
            quantity: cartItem.qas,
          }
        });

        let inventoryData = await new ProductInventory().setAll({ data: rowInventoryData }, true)
        new Cart().setCartProductInventoryData({
          CART_PRODUCT_INVENTORY_DATA: inventoryData
        });

        cart.setCartProductData({ CART_PRODUCT_DATA: cartProductData });
      }

      // 🔹 Set both CART_DATA and CART_PRODUCT_DATA

      cart.setCartData({ CART_DATA: cartData });

      let shipToAddressId = false;
      if (res.shipToAddressId !== undefined) {
        shipToAddressId = res.shipToAddressId;
      }

      cart.setCartShippingAddress({
        CART_SHIPPING_ADDRESS_ID: shipToAddressId,
      });
    } else {
      store.dispatch(SET_CLEAR_ALL_CART());
      new Cart().setCartProductInventoryData({
        CART_PRODUCT_INVENTORY_DATA: {}
      });
    }

    return res;
  };

  setWebOrderID = async (webOrderId) => {
    if (webOrderId) {
      store.dispatch(SET_CART_WEB_ORDER_ID({
        WEB_ORDER_ID: webOrderId
      }));
    }
  };

  setShippingAddressID = async (shipToAddressId) => {

    if (shipToAddressId) {
      if (shipToAddressId === 'RESET_ACTION_VALUE') {
        shipToAddressId = null;
      }
      store.dispatch(SET_CART_SHIPPING_ADDRESS_ID({
        CART_SHIPPING_ADDRESS_ID: shipToAddressId
      }));
      const c = System.getParams();
      const quoteNumber = c.quote_number;

      if (quoteNumber) {
        return
      }
      else {
        // updated for multiple call of validate because kernal is also calling for the validate cart - REMOVED UPDATION
        let server_response = await new CartRepository().fetchCartData(true, { shipToAddressId });

        return server_response;
      }

    }
  };

  // fetchProductsForCartByCartGlobalState = async () => {
  // alert('1')
  // let state = store.getState();
  // let cartDetail = state.entities?.Cart?.CART_DATA;
  // if (cartDetail) {
  //     if (cartDetail.length) {
  //         let ERPPartNumbers = [];
  //         cartDetail.map((v) => {
  //             ERPPartNumbers.push({ ERPPartNumber: v.ItemNumber });
  //         });
  //         if (ERPPartNumbers.length) {
  //             await new CartRepository().getProductForCartByERPPartNumbers(ERPPartNumbers);
  //         }
  //     } else {
  //         new Cart().setCartProductData({
  //             CART_PRODUCT_DATA: {}
  //         });
  //     }
  // } else {
  //     new Cart().setCartProductData({
  //         CART_PRODUCT_DATA: {}
  //     });
  // }
  // };

  // fetchProductsInventoryForCartByCartProductGlobalState = async () => {

  //   let state = store.getState();
  //   if (state.entities.Cart.CART_PRODUCT_DATA) {

  //     let cartProductDetail = state.entities.Cart.CART_PRODUCT_DATA;
  //     if (Object.entries(cartProductDetail).length) {
  //       let Products = [];
  //       cartProductDetail = Object.entries(cartProductDetail);
  //       cartProductDetail.map((v) => {
  //         Products.push({ ...v[1] })
  //       });
  //       if (Products.length) {
  //         await new CartRepository().getProductInventoryForCartByCartProducts(Products);
  //       }
  //     } else {
  //       new Cart().setCartProductInventoryData({
  //         CART_PRODUCT_INVENTORY_DATA: {}
  //       });
  //     }
  //   } else {
  //     new Cart().setCartProductInventoryData({
  //       CART_PRODUCT_INVENTORY_DATA: {}
  //     });
  //   }
  // };
  // syncCustomerPartNumberForPricing = async () => {
  //     let state = store.getState();
  //     if (state.entities.Cart.CART_DATA) {
  //         let CART_DATA = state.entities.Cart.CART_DATA;
  //         if (CART_DATA.length) {
  //             let BULK_CART_CUSTOMER_PART_NUMBER_ARRAY = [];
  //             CART_DATA.map((v) => {
  //                 /**
  //                  * Make here undefined condition due to accept '' for manually add cpn issue.
  //                  * Author: Devanshi Patel
  //                  */
  //                 if (v.CUSTOMER_PART_NUMBER !== undefined) {
  //                     BULK_CART_CUSTOMER_PART_NUMBER_ARRAY.push({
  //                         ItemNumber: v.ItemNumber,
  //                         CUSTOMER_PART_NUMBER: v.CUSTOMER_PART_NUMBER,
  //                     })
  //                 }
  //             });
  //             if (BULK_CART_CUSTOMER_PART_NUMBER_ARRAY.length > 0) {
  //                 store.dispatch(SET_BULK_CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT({
  //                     CART_DATA: BULK_CART_CUSTOMER_PART_NUMBER_ARRAY
  //                 }));
  //             }
  //         }
  //     }
  // };

  syncCurrencyChange = async (force_sync = false) => {
    let d = '';
    let cart_currency = false;
    let isCurrencyChanged = false
    let state = store.getState();
    if (state.entities.Cart.CART_DATA) {
      let CART_DATA = state.entities.Cart.CART_DATA;

      if (isArray(CART_DATA) && CART_DATA.length && CART_DATA[0] && CART_DATA[0].currency !== undefined) {
        cart_currency = CART_DATA[0].currency;
      }
      let sync_count = 0;
      if ((cart_currency && cart_currency !== window.mct) || (force_sync === true && cart_currency && window.mct)) {
        await new CartRepository().fetchProductsPricingForCartByCartProductGlobalState();
        isCurrencyChanged = true
      }

      if (isCurrencyChanged) {
        let CART_PRODUCT_PRICING_DATA = state.entities.Cart.CART_PRODUCT_PRICING_DATA;
        /**
         * commented due to cart error needed for update cart call optimization
         * Author: Devanshi Patel
         */
        const pArray = await Promise.all(CART_DATA.map(async (v) => {
          // await Promise.all(CART_DATA.map(async (v) => {
          let marketPrice =
            setTimeout(() => {
              new CartCommon().getCurrentPriceByQuantityAndPriceArray(CART_PRODUCT_PRICING_DATA[v.ERPMFRPartNumber + '-' + v.ERPPartNumber]?.prices, v.quantity).marketPrice;
            }, 50);

          if (marketPrice && marketPrice > 0) {
            let p = {
              "currency": window.mct,
              "cartDetailId": v.cartDetailId,
            };
            /**
             * Remove comment due to error need comment for update cart call optimization
             * Author: Devanshi Patel
             */
            // await new CartRepository().updateToCartServer(p, false);
            sync_count++;

            return p;
          }
        }));

        await new CartRepository().UpdateCartItemsServer(pArray, false);
        if (sync_count > 0) {
          d = 'SYNCED_NOW'
        }
      }
    }
    return d;
  };

  // detectPenetrationAndReturnStatus = async () => {
  //     let d = false;
  //     let state = store.getState();
  //     if (state.entities.Cart.CART_DATA && isArray(state.entities.Cart.CART_DATA)) {
  //         let CART_DATA = state.entities.Cart.CART_DATA;
  //         let CART_PRODUCT_PRICING_DATA = state.entities.Cart.CART_PRODUCT_PRICING_DATA;
  //         let sync_count = 0;
  //         await Promise.all(CART_DATA.map(async (v) => {
  //             let marketPrice = new CartCommon().getCurrentPriceByQuantityAndPriceArray(CART_PRODUCT_PRICING_DATA[v.ERPPartNumber], v.quantity).marketPrice
  //             if (marketPrice && marketPrice > 0) {
  //                 let p = {
  //                     "subtotal": parseFloat(marketPrice) * v.quantity
  //                 };
  //                 if (Math.round(p.subtotal) !== Math.round(v.subtotal)) {
  //                     sync_count++;
  //                 }
  //             }
  //         }));
  //         if (sync_count > 0) {
  //             d = true;
  //         }
  //     }
  //     return d;
  // };

  fetchProductsPricingForCartByCartProductGlobalState = async () => {
    let state = store.getState();
    if (state.entities.Cart.CART_PRODUCT_DATA) {
      let cartProductDetail = state.entities.Cart.CART_PRODUCT_DATA;
      if (Object.entries(cartProductDetail).length) {
        let Products = [];
        cartProductDetail = Object.entries(cartProductDetail);
        cartProductDetail.map((v) => {
          Products.push({ ...v[1] })
        });
        if (Products.length) {
          await new CartRepository().getProductPricingForCartByCartProducts(Products);
        }
      } else {
        new Cart().setCartProductPricingData({
          CART_PRODUCT_PRICING_DATA: {}
        });
      }
    } else {
      new Cart().setCartProductPricingData({
        CART_PRODUCT_PRICING_DATA: {}
      });
    }
  };
  // getProductForCartByERPPartNumbers = async (ERPPartNumbers) => {
  //   let p = await new ProductRepository().fetchProductObjectByERPPartNumbersNew(ERPPartNumbers);
  //   new Cart().manageOutOfSyncDisaster(p);
  //   new Cart().setCartProductData({
  //     CART_PRODUCT_DATA: p
  //   });
  //   return p;
  // };
  // getAvailableQuantity = (ERPPartNumber, CART_DATA_OBJECT = false) => {
  //     let state = store.getState();
  //     if (!CART_DATA_OBJECT) {
  //         CART_DATA_OBJECT = state.entities.Cart.CART_DATA_OBJECT;
  //     }
  //     let quantity = this.getQuantity(ERPPartNumber, CART_DATA_OBJECT);
  //     let q = parseInt(this.getInventoryQuantity(ERPPartNumber)) - quantity;
  //     if (q < 1) {
  //         q = 0;
  //     }
  //     return q;
  // };
  // getCartProductByERPPartNumber = (ERPPartNumber, CART_PRODUCT_DATA = false) => {
  //     let state = store.getState();
  //     if (!CART_PRODUCT_DATA) {
  //         CART_PRODUCT_DATA = state.entities.Cart.CART_PRODUCT_DATA;
  //     }
  //     if (CART_PRODUCT_DATA[ERPPartNumber] !== undefined) {
  //         return CART_PRODUCT_DATA[ERPPartNumber];
  //     }
  //     return false;
  // };
  getCartItemByCartDetailID = (cartDetailId, CART_DATA = false) => {
    let res = false;
    let state = store.getState();
    if (CART_DATA === false && state.entities.Cart.CART_DATA) {
      CART_DATA = state.entities.Cart.CART_DATA;
    }
    if (isArray(CART_DATA) && CART_DATA.length > 0) {
      CART_DATA.map((v) => {
        if (res !== false) {
          return;
        }
        if (v.cartDetailId === cartDetailId) {
          let tempData = { ...v }
          tempData.currency = window.mct
          res = tempData;
        }
      });
    }
    return res;
  };
  getUnadjustedQuantity = (ERPPartNumber, takePropertiesFromCart = true, quantity = 0, inventory_quantity = 0, back_order_quantity = 0) => {
    let un_q;
    if (takePropertiesFromCart === true) {
      quantity = this.getQuantity(ERPPartNumber);
      inventory_quantity = this.getInventoryQuantity(ERPPartNumber);
      back_order_quantity = this.getBackOrderQuantity(ERPPartNumber);
    }
    un_q = (quantity - inventory_quantity) - back_order_quantity;
    if (un_q < 1) {
      un_q = 0;
    }
    return un_q;
  };
  getInventoryQuantity = (ERPPartNumber, CART_PRODUCT_INVENTORY_DATA = false) => {
    let res = this.getInventoryObject(ERPPartNumber, CART_PRODUCT_INVENTORY_DATA);
    if (res && res.quantity) {
      return res.quantity;
    }
    return 0;
  };
  getInventoryLeadTime = (ERPPartNumber, CART_PRODUCT_INVENTORY_DATA = false) => {
    let res = this.getInventoryObject(ERPPartNumber, CART_PRODUCT_INVENTORY_DATA);
    if (res && res.plifz) {
      return res.plifz;
    }
    return '';
  };
  getInventoryObject = (ERPPartNumber, CART_PRODUCT_INVENTORY_DATA = false) => {
    let state = store.getState();
    if (!CART_PRODUCT_INVENTORY_DATA) {
      CART_PRODUCT_INVENTORY_DATA = state.entities.Cart.CART_PRODUCT_INVENTORY_DATA;
    }
    if (CART_PRODUCT_INVENTORY_DATA && CART_PRODUCT_INVENTORY_DATA[ERPPartNumber]) {
      return CART_PRODUCT_INVENTORY_DATA[ERPPartNumber];
    }
    return {
      quantity: 0,
      qas: 0
    };
  };
  getPricing = (ERPPartNumber, CART_PRODUCT_PRICING_DATA = false) => {
    let state = store.getState();
    if (!CART_PRODUCT_PRICING_DATA) {
      CART_PRODUCT_PRICING_DATA = state.entities.Cart.CART_PRODUCT_PRICING_DATA;
    }
    if (CART_PRODUCT_PRICING_DATA && CART_PRODUCT_PRICING_DATA[ERPPartNumber]) {
      return CART_PRODUCT_PRICING_DATA[ERPPartNumber];
    }
    return false;
  };
  getQuantity = (ERPPartNumber, CART_DATA_OBJECT = false) => {
    let state = store.getState();
    if (!CART_DATA_OBJECT) {
      CART_DATA_OBJECT = state.entities.Cart.CART_DATA_OBJECT;
    }
    if (CART_DATA_OBJECT && CART_DATA_OBJECT[ERPPartNumber] && CART_DATA_OBJECT[ERPPartNumber].quantity !== undefined) {
      return CART_DATA_OBJECT[ERPPartNumber].quantity;
    }
    return 0;
  };
  // getQuantityByItemNumber = (ItemNumber, CART_DATA_OBJECT = false) => {
  //   let state = store.getState();
  //   if (!CART_DATA_OBJECT) {
  //     CART_DATA_OBJECT = state.entities.Cart.CART_DATA_OBJECT;
  //   }

  //   if (CART_DATA_OBJECT && CART_DATA_OBJECT[ItemNumber] && CART_DATA_OBJECT[ItemNumber].quantity !== undefined) {
  //     return CART_DATA_OBJECT[ItemNumber].quantity;
  //   }
  //   return 0;
  // };
  getBackOrderQuantity = (ERPPartNumber, CART_DATA_OBJECT = false) => {
    let state = store.getState();
    if (!CART_DATA_OBJECT) {
      CART_DATA_OBJECT = state.entities.Cart.CART_DATA_OBJECT;
    }
    if (CART_DATA_OBJECT && CART_DATA_OBJECT[ERPPartNumber] &&
      CART_DATA_OBJECT[ERPPartNumber].backOrderQuantity !== undefined) {
      return CART_DATA_OBJECT[ERPPartNumber].backOrderQuantity;
    }
    return 0;
  };

  // getProductInventoryForCartByCartProducts = async (Products) => {
  //   let state = store.getState();
  //   let cartData = state.entities.Cart.CART_DATA;
  //   let rowInventoryData = cartData.map(cartItem => {
  //     return {
  //       matnr: cartItem.ERPPartNumber,
  //       plifz: cartItem.plifz,
  //       qas: cartItem.qas,
  //       quantity: cartItem.qas,
  //     }
  //   })

  //   let inventoryData = await new ProductInventory().setAll({ data: rowInventoryData }, true)
  //   new Cart().setCartProductInventoryData({
  //     CART_PRODUCT_INVENTORY_DATA: inventoryData
  //   });
  //   return inventoryData;
  // };

  getProductPricingForCartByCartProducts = async (Products) => {
    let p = await new ProductRepository().fetchProductPricingObjectByProducts(Products);
    new Cart().setCartProductPricingData({
      CART_PRODUCT_PRICING_DATA: p
    });
    return p;
  };

  replaceCartInBulk = async (params, isBulk) => {
    let items = []
    let itemNumbers = []
    if (isBulk === true) {
      if (isObject(params) && Object.keys(params).length > 0) {
        Object.entries(params).map(async (res, i) => {
          let itemData = { ...res[1] }
          if (!itemData.currency) {
            itemData.currency = window.mct
          }

          if (itemData.customerPartNumber && !itemData.cpn) {
            itemData.cpn = itemData.customerPartNumber
            itemData.CUSTOMER_PART_NUMBER = itemData.customerPartNumber
          }

          if (itemData.CUSTOMER_PART_NUMBER && !itemData.cpn) {
            itemData.cpn = itemData.CUSTOMER_PART_NUMBER
          }

          if (!itemData.CUSTOMER_PART_NUMBER) {
            itemData.cpn = ''
            itemData.CUSTOMER_PART_NUMBER = ''
          }

          if (itemData.cpnTypeName && !itemData.cpnType) {
            itemData.cpnType = itemData.cpnTypeName
          }
          if (!itemData.hazardousFlag) {
            itemData.hazardousFlag = itemData?.product?.HazardousFlag
          }
          if (itemData.product && itemData.product.ItemNumber) {
            itemData.itemNumber = itemData.product.ItemNumber
            itemData.manufacturerName = itemData.product.ManufacturerName
            itemData.ERPManufacturerName = itemData.product.ERPManufacturerName
            itemData.manufacturerPartNumber = itemData.product.ManufacturerPartNumber
            itemData.partNumber = itemData.product.ERPPartNumber
            if (itemData.partNumber && ProductRepository.detectStringIsItemNumber(itemData.partNumber)) {
              itemData.partNumber = itemData.product.ItemNumber
            }
            itemData.manufacturerCode = itemData.product.ManufacturerCode
            itemData.ERPManufacturerCode = itemData.product.ERPManufacturerCode
            itemData.erpMfrPartNumber = itemData.product.ERPMFRPartNumber

            itemNumbers.push(itemData.product.ItemNumber)
            delete itemData.product;
          }
          items.push(itemData)
        })
      }
    } else {

      /**
       * Ticket #  : 9660
       * Change #  : Added the unit price when replace CPN
       * Change by : Pankaj
       * Date      : 14 March 2023
       */

      if (params.ItemNumber) {
        itemNumbers.push(params.ItemNumber)
      }

      if (params.customerPartNumber && !params.cpn) {
        params.cpn = params.customerPartNumber
        params.CUSTOMER_PART_NUMBER = params.customerPartNumber
      }

      if (params.CUSTOMER_PART_NUMBER && !params.cpn) {
        params.cpn = params.CUSTOMER_PART_NUMBER
      }

      if (!params.CUSTOMER_PART_NUMBER) {
        params.cpn = ''
        params.CUSTOMER_PART_NUMBER = ''
      }
      // DT - 15Feb -9231: Already added qty showing insufficient inventory validation instead of backordered
      // wrong Property passed so replace property & removewrong property
      /**
       * Author : Pankaj and trilok
       * date: 28/02/2023
       * reason: solve extensible error
       */
      let paramsClone = produceClone(params)
      paramsClone.backOrderedQuantity = params.backOrderQuantity
      items.push(paramsClone)
    }

    let replaceCartParam = {
      currency: params.currency ? params.currency : window.mct,
      type: "Shopping",
      cartItems: items
    }
    let server_response = await new CartService().replaceCartInBulk(replaceCartParam);
    const result = server_response.data.cartItems.filter(item => itemNumbers.includes(item.itemNumber));

    if (isBulk === true) {
      let response_data = result
      store.dispatch(system_notification({
        name: 'AddedToCartBomPopup',
        data: {
          cartData: response_data,
          isCartBOM: true
        },
      }));
      __set('CART_API_CALL');
      await new CartRepository().initiatedKernelCall();
      __remove('CART_API_CALL');

    } else {
      let response_data = {}
      response_data.data = result[0]
      if (server_response) {
        __set('CART_API_CALL');

        // await new CartRepository().fetchCartCount();

        /**
         * View cart API call when new product add in cart
         * Author: Devanshi Patel
         */
        await new CartRepository().fetchCartData(false, { minicart: true });

        let data = {
          server_response: response_data,
          params
        }
        let openAddedToCartNotification = true;
        if (data?.params?.dontOpenAddedToCartPopup !== undefined &&
          data.params.dontOpenAddedToCartPopup === true) {
          openAddedToCartNotification = false;
        }
        //It should be at last
        if (openAddedToCartNotification) {
          await store.dispatch(await system_notification({
            name: 'AddedToCartNotification',
            data: data,
          }));
        }
        __remove('ADD_TO_CART_API_CALL')
        __remove('CART_API_CALL');

      }
    }
  }

  /**
   * create new function for add to cart due to optimization in add to cart and manually add to cart
   * Author: Devanshi Patel
  //  */
  // addToCartServer = async (params, isManuallyAddCart, additionSource) => {
  //   store.dispatch(SET_CART_LOADER_DATA_OBJECT({}))
  //   if (!isManuallyAddCart) {
  //     params = this.attachCustomerPartNumberBeforeServerCall(params);
  //   }
  //   if (params.cpn === undefined)
  //     params.cpn = this.setCpnForAddToCart(params)

  //   if (!params.currency) {
  //     params.currency = window.mct
  //   }

  //   let server_response = ''
  //   server_response = await new CartService().addToCartServer(params);
  //   if (server_response) {
  //     if (isManuallyAddCart) {
  //       __set('CART_API_CALL');
  //       await new CartRepository().initiatedKernelCall();
  //       __remove('CART_API_CALL');

  //     } else {
  //       __set('CART_API_CALL');

  //       // await new CartRepository().fetchCartCount();

  //       /**
  //        * View cart API call when new product add in cart
  //        * Author: Devanshi Patel
  //        */
  //       await new CartRepository().fetchCartData(false, { minicart: true });

  //       let data = {
  //         server_response,
  //         params,
  //         additionSource
  //       }

  //       let openAddedToCartNotification = true;
  //       if (data?.params?.dontOpenAddedToCartPopup !== undefined &&
  //         data.params.dontOpenAddedToCartPopup === true) {
  //         openAddedToCartNotification = false;
  //       }
  //       //It should be at last
  //       if (openAddedToCartNotification) {
  //         await store.dispatch(await system_notification({
  //           name: 'AddedToCartNotification',
  //           data: data,
  //         }));
  //       }
  //       __remove('ADD_TO_CART_API_CALL')
  //       __remove('CART_API_CALL');
  //     }
  //   }
  //   // }
  //   return server_response;
  // };


  addToCartServer = async (params, isFrom, productData, isManuallyAddCart) => {
    store.dispatch(SET_CART_LOADER_DATA_OBJECT({}))
    let server_response = ''

    server_response = await new CartService().addToCartServer(params)

    if (server_response) {
      __set('CART_API_CALL');

      let data = {
        server_response,
        params
      }

      if (server_response?.data?.showPriceQtyMissMatch) {
        store.dispatch(system_notification({
          name: 'PriceMisMatch',
          data: {
            single_product: productData,
            PRODUCT_PRICE: productData.minQtyPrice,
            cart_params: params,
            isFrom: isFrom,
            isFromManualCart: isManuallyAddCart
          },
        }));

      } else if (server_response?.data?.isExists === true) {
        System.popup('CartItemReplacePopup', { product: productData, cartReplaceItem: params, isFrom: isFrom, isFromManualCart: isManuallyAddCart })
      } else if (server_response?.data?.isBackOrderConfirmation === true) {
        if (productData.ObsoleteFlag) {
          System.popup('ObsoleteOutOfStockPopup', {//quantity below
            ERPMFRPartNumber: params.ERPMFRPartNumber, ObsoleteFlag: productData.ObsoleteFlag, quantity: params.currentStock
          });
        } else {
          store.dispatch(system_notification({
            name: 'InventoryAlertForAddToCartPopup',
            data: {
              single_product: productData,
              isManuallyAddCart: isManuallyAddCart,
              isFrom: isFrom,
              cartRes: server_response.data,
              addToCartParam: params
            },
          }));
        }
      } else {

        if (isManuallyAddCart) {
          await new CartRepository().fetchCartData();
        } else {
          await store.dispatch(await system_notification({
            name: 'AddedToCartNotification',
            data: data,
          }));
        }
      }
      __remove('ADD_TO_CART_API_CALL')
      __remove('CART_API_CALL');
    }
    return server_response;
  };

  // setCpnForAddToCart = (params) => {
  //   let state = store.getState();
  //   // partNumber === ERPPartNumber so dont be confused
  //   const CART_BEFORE_TO_SEND_SERVER = state.entities.Cart.CART_BEFORE_TO_SEND_SERVER[params.ItemNumber];

  //   let cpn = new ProductRepository().getProductPricingCPNOut(CART_BEFORE_TO_SEND_SERVER)
  //   return cpn;
  // };

  addCartInBulk = async (items) => {
    if (items?.type !== undefined && items?.type === 'Quote') {
      let res = await new CartService().addCartInBulk(items)
      return res && res.data && res.data.cartItems
    }
    else {
      var cartItems = [];
      if (items !== undefined &&
        Object.entries((items).length > 0)) {
        const productCartData = await new ProductRepository().attachProductAndInventoryToAnyObjectNew(items, false, false);

        if (productCartData !== undefined && Object.entries(productCartData).length > 0) {
          const _data = await this.getBulkCartItems(productCartData);
          const productCartItems = produceClone(_data);
          for (let i = 0; i < Object.entries(productCartData).length; i++) {
            let v = Object.entries(productCartData)[i];

            let quantity = v[1].quantity

            let customerPartNumber = await new CartRepository().getCustomerPartNumberFromERPPArtNumber(v[1].product.ItemNumber)

            if (quantity >= v[1].product.QtyMin && quantity % v[1].product.QtyMult === 0) {
              let cartItemParams = {}
              cartItemParams.ERPPartNumber = v[1].product?.ERPPartNumberModified ? "" : v[1].product.ERPPartNumber
              cartItemParams.partNumber = v[1].product?.ERPPartNumberModified ? "" : v[1].product.ERPPartNumber

              if (cartItemParams.partNumber !== undefined && cartItemParams.partNumber && ProductRepository.detectStringIsItemNumber(cartItemParams.partNumber)) {
                cartItemParams.partNumber = v[1].product.ItemNumber
              }

              cartItemParams.ItemNumber = v[1].product.ItemNumber
              cartItemParams.ManufacturerPartNumber = v[1].product.ManufacturerPartNumber
              cartItemParams.ERPMFRPartNumber = v[1].product.ERPMFRPartNumber
              cartItemParams.manufacturerCode = v[1].product.ManufacturerCode
              cartItemParams.quantity = v[1].quantity
              cartItemParams.backOrderedQuantity = 0
              cartItemParams.manufacturerName = v[1].product.ManufacturerName
              cartItemParams.LongDescription = v[1].product.LongDescription
              cartItemParams.cpn = v[1].customerPartNumber ? v[1].customerPartNumber : customerPartNumber
              cartItemParams.customerPartNumber = v[1].customerPartNumber ? v[1].customerPartNumber : customerPartNumber
              cartItemParams.currency = window.mct
              cartItemParams.ShortDescription = v[1].product.ShortDescription
              cartItemParams.AssetURL = v[1].product.AssetURL
              cartItemParams.manufacturerCode = v[1].product.ManufacturerCode
              cartItemParams.erpManufacturerName = v[1].product?.ERPManufacturerName
              cartItemParams.erpManufacturerCode = v[1].product?.ERPManufacturerCode
              cartItemParams.cpnType = v[1]?.cpnTypeName
              cartItemParams.manualCPN = v[1]?.manualCPN ? v[1].manualCPN : ''
              cartItemParams.vendorCode = v[1].product?.VendorCode
              cartItemParams.sapMatGroup = v[1].product?.SAPMatgroup
              cartItemParams.hazardousFlag = v[1].product?.HazardousFlag
              // cartItemParams.addedFromBom = true
              // if (v[1]?.cpnTypeName === Constants.cpnTypes.MANUALCPN) {
              //     cartItemParams.manualCPN = v[1]?.manualCPN
              // }
              const cloneObj = produceClone(cartItemParams);
              cartItems.push(cloneObj);
            }
          }
          let params = {}
          params.currency = window.mct
          params.cartItems = cartItems
          let res = await new CartService().addCartInBulk(params)
          res.data.cartItems && res.data.cartItems.map((v, i) => {
            cartItems && cartItems.map((p, j) => {
              if (v.itemNumber === p.ItemNumber) {
                res.data.cartItems[i].ShortDescription = p.ShortDescription
              }
            })
          })

          let itemsInResponse = []

          params.cartItems?.map((item) => {
            itemsInResponse = [...itemsInResponse, ...res.data.cartItems?.filter((itemInRes) => itemInRes?.partNumber == item.partNumber)]
          })

          itemsInResponse.forEach((item) => {
            const responseFromCartAPI = res.data.cartItems?.find((itemInRes) => itemInRes?.partNumber == item.partNumber)
            const currentItemIndex = itemsInResponse.findIndex((existingItem) => existingItem.partNumber == item.partNumber)
            itemsInResponse[currentItemIndex] = { ...responseFromCartAPI, ...itemsInResponse[currentItemIndex] }
          });

          const arrWithoutDuplicates = itemsInResponse.reduce((accumilator, currentVal) => {
            const found = accumilator.find((x) => x.itemNumber == currentVal.itemNumber && x.cpn == currentVal.cpn)

            if (!found) {
              accumilator.push({ ...currentVal })
            }
            return accumilator;
          }, [])

          return arrWithoutDuplicates
        }
        return productCartData
      }
    }

    return false
  };
  // // Pricing Optimization for obsolete parts
  // // CR #     : 9654
  // // Author # : Pankaj
  // getUnitPriceByPartNumberQty = async (ManufacturerCode, ERPPartNumber, ItemNumber, Qty, product) => {
  //     let params = []
  //     if (ManufacturerCode === undefined || ManufacturerCode === null || ManufacturerCode === '' ||
  //         ERPPartNumber === undefined || ERPPartNumber === null || ERPPartNumber === '' ||
  //         ItemNumber === undefined || ItemNumber === null || ItemNumber === '' ||
  //         isNaN(Qty) || Qty === undefined || Qty == null || Number(Qty) === 0) {
  //         return 0;
  //     }
  //     params.push({
  //         ManufacturerCode: ManufacturerCode,
  //         PartNumber: ERPPartNumber,
  //         ItemNumber: ItemNumber,
  //         assets: {
  //             product: product
  //         }
  //     })


  //     let pricingResult = await new ProductPricingAPICall().getPricingNew(params);

  //     if (pricingResult !== undefined && pricingResult !== null && pricingResult[ERPPartNumber] !== undefined && pricingResult[ERPPartNumber] !== null &&
  //         Array.isArray(pricingResult[ERPPartNumber])) {
  //         let qtyExactResult = pricingResult[ERPPartNumber].find(x => x.demandQuantityOut === Qty);
  //         // Check Exact Quantity
  //         if (qtyExactResult !== undefined && qtyExactResult !== null &&
  //             qtyExactResult.marketPrice !== undefined && qtyExactResult.marketPrice !== null &&
  //             Number(pricingResult[ERPPartNumber].find(x => x.demandQuantityOut === Qty).marketPrice) > -1) {
  //             return Number(pricingResult[ERPPartNumber].find(x => x.demandQuantityOut === Qty).marketPrice);
  //         }
  //         // Check Last First Quantity
  //         let qtySimilarResult = pricingResult[ERPPartNumber].filter(x => x.demandQuantityOut <= Qty);

  //         if (qtySimilarResult !== undefined
  //             && qtySimilarResult !== null
  //             && Array.isArray(qtySimilarResult)
  //             && qtySimilarResult.length > 0) {
  //             return qtySimilarResult.at(-1).marketPrice
  //         }
  //     }
  //     return 0;
  // }

  getBulkCartItems = async (cartData) => {
    let duplicateItems = {};
    if (cartData && Object.entries((cartData).length > 0)) {
      Object.entries(cartData).forEach((x) => {
        if (duplicateItems[x[1].ERPPartNumber] === undefined) {
          duplicateItems[x[1].ERPPartNumber] = [];
        }
        duplicateItems[x[1].ERPPartNumber].push({ quantity: x[1].quantity })
      });
    }
    return Object.keys(duplicateItems).length > 0 ? duplicateItems : [];
  }

  updateToCartServer = async (params, fireUpdateEvent = true) => {
    params = this.attachCustomerPartNumberBeforeServerCall(params);
    let server_response = await new CartService().updateToCartServer(params);
    if (server_response && fireUpdateEvent === true) {
      __set('CART_API_CALL');
      await new CartRepository().initiatedKernelCall({ isCountRequired: false });
      __remove('CART_API_CALL');
    }
    return server_response;
  };

  UpdateCartItemsServer = async (arrayParams, fireUpdateEvent = true, cartDetailItem = false) => {
    let updateArrayParams = ''
    let paramsWithwholeCartItem = ''
    if (cartDetailItem) {
      paramsWithwholeCartItem = arrayParams;
    } else {
      updateArrayParams = arrayParams.map(params => this.attachCustomerPartNumberBeforeServerCall(params))
      paramsWithwholeCartItem = updateArrayParams.map(params => new CartRepository().getCartItemByCartDetailID(params.cartDetailId));
    }

    const requestPayload = {
      cartId: paramsWithwholeCartItem[0].cartId,
      cartDetailItems: paramsWithwholeCartItem
    }
    let server_response = await new CartService().updateCartItemsServer(requestPayload);
    if (server_response && fireUpdateEvent === true) {
      __set('CART_API_CALL');
      await new CartRepository().initiatedKernelCall();
      __remove('CART_API_CALL');
    }
    return server_response;
  };

  updateReferencePartNumberByCartDetailID = async (cartDetailId, referencePartNumber = null) => {
    await new CartService().updateReferencePartNumberByCartDetailID(cartDetailId, referencePartNumber);
  };
  // attachUnitPriceAndSubTotalToItemBeforeServerCall = (params, CART_PRICE_BEFORE_TO_SEND_SERVER = false) => {
  //     let state = store.getState();
  //     if (!CART_PRICE_BEFORE_TO_SEND_SERVER) {
  //         CART_PRICE_BEFORE_TO_SEND_SERVER = state.entities.Cart.CART_PRICE_BEFORE_TO_SEND_SERVER;
  //     }
  //     // partNumber === ERPPartNumber so dont be confused
  //     if (CART_PRICE_BEFORE_TO_SEND_SERVER[params.partNumber] !== undefined) {
  //         if (!params.unitPrice) {
  //             params.unitPrice = parseFloat(CART_PRICE_BEFORE_TO_SEND_SERVER[params.partNumber].unitPrice);
  //         }

  //         if (!params.subtotal) {
  //             params.subtotal = params.unitPrice * params.quantity;
  //         }
  //     }
  //     return params;
  // };

  attachCustomerPartNumberBeforeServerCall = (params, CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER = false) => {
    let state = store.getState();
    if (!CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER) {
      CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER = state.entities.Cart.CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER;
    }
    // partNumber === ERPPartNumber so dont be confused
    if (CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[params.ItemNumber] &&
      CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[params.ItemNumber].CUSTOMER_PART_NUMBER &&
      params.CUSTOMER_PART_NUMBER === undefined) {
      params.CUSTOMER_PART_NUMBER = CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[params.ItemNumber].CUSTOMER_PART_NUMBER;
      params.cpn = CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[params.ItemNumber].CUSTOMER_PART_NUMBER;
    }
    return params;
  };
  getCustomerPartNumberFromERPPArtNumber = (ItemNumber, CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER = false) => {
    let state = store.getState();
    if (!CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER) {
      CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER = state.entities.Cart.CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER;
    }
    // partNumber === ERPPartNumber so dont be confused
    if (CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[ItemNumber] &&
      CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[ItemNumber].CUSTOMER_PART_NUMBER) {
      return CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[ItemNumber].CUSTOMER_PART_NUMBER;
    }
    return '';
  };

  clearAllCartFromServer = async () => {
    return await new CartService().clearAllCartFromServer();
  };

  clearSingleCartProductFromFromServerByCartDetailId = async (cartDetailId) => {
    let server_response = await new CartService().clearSingleCartProductFromFromServerByCartDetailId(cartDetailId);
    if (server_response) {
      __set('CART_API_CALL');
      await new CartRepository().fetchCartData();
      __remove('CART_API_CALL');

      System.alert('', 'clear')
    }
    return server_response;
  };

  // getUserID = async () => {
  //     return await this.setUUIDOnKey('userID');
  // };
  // getSpeedBoat = async () => {
  //     return this.setUUIDOnKey('speedBoat');
  // };
  // getAccountNumber = async () => {
  //     return this.setUUIDOnKey('accountNumber');
  // };
  getCartID = async () => {
    return this.setUUIDOnKey('cartID');
  };
  setCartID = async (value) => {
    let l = await this.setValueToCart('cartID', value);
    if (l) {
      return l;
    }
    return false;
  };
  setValueToCart = async (key, value) => {
    let cart = await localStorage.getItem(this.get_LOCAL_STORAGE_NAME());
    if (cart) {
      cart = await JSON.parse(cart);
    } else {
      cart = {}
    }
    cart[key] = value;
    await localStorage.setItem(this.get_LOCAL_STORAGE_NAME(), JSON.stringify(cart));
    return this.getValueFromCart(key);
  };
  setUUIDOnKey = async (key) => {
    let l = await this.getValueFromCart(key);
    if (l) {
      return l;
    }
    if (key === 'userID') {
      l = await Auth.getUserID();
    } else if (key === 'speedBoat') {
      l = await Auth.getAuthSBoat();
    } else if (key === 'accountNumber') {
      l = await Auth.getAccountNumber();
    } else if (key === 'cartID') {
      //Writing Nothing is skipping the call to default condition,
      //So do not remove it.
    } else {
      l = await Helper.UUID();
    }
    return this.setValueToCart(key, l);
  };
  getValueFromCart = async (key) => {
    let l = await this.getCart([key]);
    if (l[key] === undefined) {
      return false;
    }
    return l[key];
  };
  getCart = async () => {
    let cart = await localStorage.getItem(this.get_LOCAL_STORAGE_NAME());
    if (cart) {
      cart = await JSON.parse(cart);
    } else {
      cart = {}
    }
    return cart;
  };

  scheduleShippingApply = async (params) => {
    let server_response = await new CartService().scheduleShippingApply(params);
    if (server_response) {
      __set('CART_API_CALL');
      await new CartRepository().initiatedKernelCall({ isCountRequired: false });
      __remove('CART_API_CALL');


    }
    return server_response;
  };
  updateBackOrderQuantityToCartServer = async (cartDetailItems) => {
    let server_response = await new CartService().updateBackOrderQuantityToCartServer({
      cartDetailItems
    });
    if (server_response) {
      await new CartRepository().initiatedKernelCall();
    }
    return server_response;
  };


  // getVatData = async () => {
  //     return await new CartService().getVatData();
  // };
  getMrfCodeToValidateToShip = async (countryCode) => {
    return await new CartService().getMrfCodeToValidateToShip(countryCode);
  };
  checkisValidProduct = (mfrCode) => {
    let state = store.getState();
    const mfrCodeList = state.entities.Cart.MFR_CODE_LIST_SHIP_TO_VALIDATE;
    let isInvalid = false;
    if (mfrCodeList && mfrCodeList.length > 0) {
      isInvalid = ((mfrCodeList?.findIndex(f => f === mfrCode)) > -1) ? false : true;
    }
    return isInvalid;
  }

  checkisAnyInvalidProduct = (quoteNumber) => {
    let isInvalid = false;
    if (quoteNumber) {
      let state = store.getState();
      const lineItems = state.entities?.model_QuoteDetail?.cart_quote_active_session[quoteNumber]?.records;
      const mfrCodeList = state.entities.Cart.MFR_CODE_LIST_SHIP_TO_VALIDATE;
      if (lineItems && mfrCodeList && mfrCodeList.length > 0) {
        Object.entries(lineItems).forEach(ele => {
          if (isInvalid === false) {
            isInvalid = ((mfrCodeList?.findIndex(f => f === ele[1].erpManufacturerCode)) > -1) ? false : true;
          }
        });
      }
    }

    return isInvalid;
  }

  getCartListSubTotal = (CART_DATA) => {  // Remove dependency of Thunk & redux - Optimized for get_cart_subtotal & getCartSubTotal
    let total = 0
    if (CART_DATA && CART_DATA[0] && CART_DATA[0].currency !== undefined) {
      CART_DATA.map((v) => (
        total = total + v.subtotal
      ));
    }
    return total;
  };


  getQuoteCartSubTotal = (quoteList) => {
    let total = 0
    if (quoteList && Object.entries(quoteList).length > 0) {
      Object.entries(quoteList).map((v) => {
        total = total + (v[1][`quantity_${v[1].quantity_field_selected}`]) * v[1][`quotedPrice_${v[1].quantity_field_selected}`];

      });
    }
    return total;
  };


  checkItemExistsInCart = async (checkItemParam) => {
    return await new CartService().checkItemExistsInCart(checkItemParam);
  };
  getUpdatedQty = (product, CART_BEFORE_TO_SEND_SERVER) => {
    let _product = produceClone(product);
    const _serverProduct = CART_BEFORE_TO_SEND_SERVER[product.ItemNumber];
    if (_serverProduct && _serverProduct !== undefined && _serverProduct?.quantityAddToCart && _serverProduct?.quantityAddToCart !== undefined) {
      _product.Quantity = _serverProduct?.quantityAddToCart;
    }
    return _product;
  }
  setShippingAddress = (addressList, shippingAddressId) => {
    localStorage.setItem("CART_SHIPPING_ADDRESS_ID", shippingAddressId);
    if (addressList !== undefined && addressList.length > 0) {
      let _address = addressList.find(f => f.shipToAddressId === shippingAddressId)
      _address = JSON.stringify(_address)
      localStorage.setItem("CART_SHIPPING_ADDRESS", _address)
    }
  }
  getShippingAddress = () => {
    const _address = localStorage.getItem("CART_SHIPPING_ADDRESS")
    return _address ? JSON.parse(_address) : false;
  }

  initiatedKernelCall = async (params = {}) => {
    await new CartRepository().fetchCartData();
    // if (params?.isCountRequired === false) { } else {
    //     await new CartRepository().fetchCartCount();
    // }
    // await new CartRepository().fetchProductsForCartByCartGlobalState();
    // await new CartRepository().fetchProductsInventoryForCartByCartProductGlobalState();
  };
  // checkItemsForBlackListedCountry = async (params) => {
  //     return await new CartService().checkItemsForBlackListedCountry(params);
  // };

  getCheckoutCharge = async () => {
    return await new CartService().getCheckoutCharge();
  };


}

export default CartRepository;